import React from 'react';
import { Row, Container, Card, Button, Form } from 'react-bootstrap';
import ProductStore from '../store/product-store.js';
import ProductService from '../services/product-service.js';
import Translation from '../store/internationalization-store.js';
import Popup from '../components/popup/comfirmation_popup.js'
import Constants from '../constants.js';
import Config from '../classes/config.js';

export default class HelpVideos extends React.Component {

    constructor(props) {
        super();
        this.props = props;
        this.state = {
            show: false,
            currentVideo: -1,
            cards: [],
            currentVideoTitle: '',
            currentVideoDescription: '',
            currentVideoURL: '',
            allData: {}
        }
    }

    createCards(data) {
        data.sort((a, b) => a.order > b.order ? 1 : -1);
        var cards = [];
        for (const x in data) {
            var curData = data[x];
            if (curData.serve_to == "China") {
                cards.push(
                    <Card style={{ width: '20rem', marginLeft: 15, marginRight: 15, marginTop: 30, border: "solid 1px grey" }} className="help-video-card">
                        <Card.Body>
                            <div style={{ minHeight: '80px' }}>
                                <Card.Title style={{ minHeight: '25px' }}>{Translation.get(0, curData.title)}</Card.Title>
                            </div>
                            <Button style={{ backgroundColor: '#22153D', border: 'none' }} onClick={this.playVideo.bind(this, curData)}><i class="fas fa-play-circle"></i> Play video </Button>
                        </Card.Body>
                    </Card>
                )
            }
        }
        return cards;
    }

    playVideo(video) {
        this.setState({ show: true, currentVideoTitle: video.title, currentVideoDescription: video.description, currentVideoURL: video.video_url });
    }

    componentWillMount() {
        ProductStore.on(Constants.GET_VIDEO_DATA, () => {
            var videoData = ProductStore.getVideoData();
            this.setState({
                cards: this.createCards(videoData.results),
                allData: videoData.results
            })
        });
    }

    componentDidMount() {
        ProductService.getVideoData();
    }

    render() {
        var urlStuff = 'https://storage.languagenut.com/';

        if (window.location.href.indexOf(".cn") > -1) {
            urlStuff = 'https://www.languagenut.cn/sales/images/';
        }
        return <Row className='justify-content-md-center'>
            <div style={{ backgroundColor: 'white', width: '90%', borderStyle: 'solid', borderColor: '#f0f0f0', borderWidth: '1px', paddingBottom: '25px' }}>
                <Popup oneButton={true} onHide={() => { this.setState({ show: false }) }} onSave={() => { this.setState({ show: false }) }} show={this.state.show} buttonTitle={Translation.get(0, 'Close')} title={Translation.get(0, this.state.currentVideoTitle)}
                    body={<div>
                        {Translation.get(0, this.state.currentVideoDescription)}
                        <div style={{ marginTop: 20 }}>
                            <video width='100%' controls autoPlay>
                                <source src={urlStuff + this.state.currentVideoURL} type='video/mp4' />
                            </video>
                        </div>
                    </div>} />
                <Row className='justify-content-md-center'>
                </Row>
                <Row className='justify-content-md-center'>
                    <div style={{ width: "100%" }}>
                        <div style={{ fontSize: 25, fontWeight: 'bold', marginTop: '30px', marginLeft: '120px', float: "left" }}>{Translation.get(0, "Languagenut's Help Videos")}</div>
                        <div style={{ float: "right", marginRight: '120px' }}><Form>
                            <Form.Control type='search' placeholder={Translation.get(595, 'Search')} style={{ width: 400, marginTop: 30, marginBottom: 30 }} onChange={(e) => {
                                this.setState({
                                    ...this.state,
                                    show: false,
                                    cards: this.createCards(Object.values(this.state.allData).filter(x => {
                                        return x.title.toLowerCase().includes(e.target.value.toLowerCase());
                                    }))
                                })
                            }} ></Form.Control>
                        </Form>
                        </div>
                    </div>
                </Row>
                <Row className='justify-content-md-center'>
                    <div style={{ display: 'flex', justifyContent: 'center', width: 1500, flexWrap: 'wrap' }}>
                        <div style={{ width: '80%', borderTop: "solid 1px grey" }}></div>
                        {this.state.cards}
                    </div>
                </Row>
            </div>
        </Row>
    }
}